import { useFormContext } from 'react-hook-form'
import { FormLoginData } from '../useLoginController'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../../../app/hooks/useAuth'
import { authService } from '../../../../app/services/authService'
import {
  SignInParams,
  getUnicoValidationUserId,
  isUnicoValidationRequired,
} from '../../../../app/services/authService/signIn'
import { useSetAtom } from 'jotai'
import { userIdentity } from '@/app/store'
import { useToast } from '../../../components/ui/use-toast'
import { UserRoleEnum } from '@/app/services/usersService/user'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'

export const useLoginFormController = () => {
  const methods = useFormContext<FormLoginData>()

  const { toast } = useToast()
  const { logout } = useWhitelabelContext()
  const navigate = useNavigate()
  const setUserIdentity = useSetAtom(userIdentity)

  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (data: SignInParams) => {
      return authService.signin(data)
    },
  })

  const { signin } = useAuth()

  const handleFormSubmit = async (data: FormLoginData) => {
    try {
      const { accessToken, user } = await mutateAsync(data)

      if (!accessToken) {
        toast({
          variant: 'destructive',
          title: 'Login inválido, tente novamente mais tarde.',
        })
        return
      }

      signin(accessToken)

      if (user?.role === UserRoleEnum.SUPPORT) navigate('/support')
      else navigate('/transacoes')

      toast({
        title: 'Login bem sucedido!',
      })
    } catch (error) {
      if (isUnicoValidationRequired(error)) {
        const id = getUnicoValidationUserId(error)
        if (id) setUserIdentity((prev) => ({ ...prev, id }))
        navigate('/analising')
        return
      }

      toast({
        variant: 'destructive',
        title: 'Credenciais inválidas!',
      })
    }
  }

  const handleChangeWhitelabel = () => {
    logout()
    navigate('/')
  }

  return {
    methods,
    isPending,
    handleFormSubmit,
    handleChangeWhitelabel,
  }
}
